import companyLogo from 'assets/funnel/powerserv_logo_2.png';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

// TODO: placeholder paths — drop the real images in src/assets/funnel/ with these filenames
import heroImg from 'assets/funnel/auto_elek_1019_1.jpg';
import infoHeroImg from 'assets/funnel/auto_elek_1019_2.jpg';
import jobDetailsImg from 'assets/funnel/auto_elek_1019_3.jpg';
import groupImg from 'assets/funnel/auto_elek_1019_4.jpg';

const auto_elek_1019 = {
  documentTitle: "Kraftfahrzeugelektriker (m/w/d) mit Erfahrung | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Vollzeit · €3.500 / Monat · Wien",
    heroTitle: "Kraftfahrzeugelektriker (m/w/d) · Nutzfahrzeuge",
    heroSubtitle: "Reparaturen an Nutzfahrzeugen mit Schwerpunkt Fahrzeugelektrik bei einem führenden europäischen Nutzfahrzeughersteller in 1210 Wien.",
    facts: [
      { icon: 'bi-cash-stack',   title: '€ 3.500,– / Monat',       subtitle: 'Brutto-Mindestlohn + Überzahlung möglich' },
      { icon: 'bi-geo-alt-fill', title: '1210 Wien',                subtitle: 'Standort' },
      { icon: 'bi-clock',        title: '38,5-Stunden-Woche',       subtitle: 'Mo–Do 07:00–17:00, Fr bis 15:00' },
      { icon: 'bi-shield-check', title: 'Direktanstellung',         subtitle: 'keine Arbeitskräfteüberlassung' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · Kfz-Elektrik & Nutzfahrzeuge",
    heroTitleLines: ["Kraftfahrzeugelektriker", "(m/w/d)"],
    facts: [
      { value: "€ 3.500", label: "Brutto-Mindestlohn + Überzahlung möglich" },
      { value: "Vollzeit", label: "1210 Wien" },
    ],
    moechtestDuItems: [
      { icon: 'bi-tools',         text: 'Reparaturen an Nutzfahrzeugen mit Schwerpunkt Fahrzeugelektrik durchführen – vom Verkabeln bis zur Montage von Steckverbindungen?' },
      { icon: 'bi-search',        text: 'Fehlersuche und Diagnose an Fahrzeugelektronik mit Diagnose-Laptop, Multimeter und Oszilloskop durchführen?' },
      { icon: 'bi-graph-up-arrow', text: 'bei einem führenden europäischen Nutzfahrzeughersteller direkt angestellt langfristig durchstarten – ganz ohne Arbeitskräfteüberlassung?' },
    ],
    benefits: [
      { icon: 'bi-shield-check', title: 'Direktanstellung',        desc: 'Direktanstellung bei unserem Kunden – keine Arbeitskräfteüberlassung.' },
      { icon: 'bi-clock',        title: 'Geregelte Arbeitszeiten', desc: '38,5-Stunden-Woche: Montag–Donnerstag 07:00–17:00 Uhr, Freitag bis max. 15:00 Uhr.' },
      { icon: 'bi-p-square',     title: 'Kostenloser Firmenparkplatz', desc: 'Kostenfreier Firmenparkplatz am Firmengelände.' },
      { icon: 'bi-cash-stack',   title: '€ 3.500 Monatslohn',      desc: 'Monatslohn von € 3.500 brutto mit Überzahlungsmöglichkeit je nach Berufserfahrung.' },
      { icon: 'bi-people',       title: 'Dynamisches Team',        desc: 'Abwechslungsreiche Tätigkeit in einem dynamischen Team.' },
    ],
    aufgabenTitle: "Fahrzeugelektrik mit Präzision.",
    tasks: [
      'Reparaturen an Nutzfahrzeugen mit Schwerpunkt Fahrzeugelektrik',
      'Vorbereiten von Kabeln und Leitungen (Abmanteln und Isolieren)',
      'Verlegen von Kabeln in Kanälen, Rohren und Geflechtsschläuchen',
      'Montage verschiedener Steckverbindungen und Komponenten',
      'Prüfung und Messung von Leitungsverlegungen sowie Anschluss von Bauteilen (z. B. Lichter, Drehleuchten)',
      'Fehlersuche und Diagnose an Fahrzeugelektronik',
    ],
    requirements: [
      'Abgeschlossene Berufsausbildung im Bereich Kfz-Elektrik oder Mechatronik',
      'Mindestens 3 Jahre Berufserfahrung im Bereich Elektrik in einer Werkstatt erforderlich',
      'Fundierte Kenntnisse in Elektrik, Elektronik und Mechanik',
      'Sicherer Umgang mit Diagnosewerkzeugen (z. B. Diagnose-Laptop, Multimeter, Oszilloskop)',
      'Erfahrung in der Verkabelung und Montage elektrischer Anlagen im Fahrzeugbau',
      'Führerschein B',
      'Teamfähigkeit und Verlässlichkeit',
      'Deutschkenntnisse mindestens B2',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Kfz-Elektrik &", "Nutzfahrzeuge"],
    noteText: "Erfahrung in der Fahrzeugelektrik und handwerkliches Geschick? Dann bewirb dich jetzt – wir freuen uns auf dich.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default auto_elek_1019;
